import React from "react";
import { CustomButton } from "../UI/CustomButtons";
import { useDispatch } from "react-redux";
import { openPopup } from "../../_store/reducers/trainAIPopupReducer";
import CustomTable from "./CustomTable";

const SEARCH_CONFIG = {
  column: "Session Title",
  placeholder: "Search Session",
};

function Sessions({ styles, data = {}, category, onPageChange, onVisibilityFilter, onSearchChange, searchValue, onDateFilterChange }) {
  const dispatch = useDispatch();

  const noDataImg = `${process.env.PUBLIC_URL}/img/no-data.png`;
  const noData = Object.keys(data).length === 0;

  const handleAddSession = () => {
    dispatch(openPopup());
  };

  return (
    <div style={{ width: "70%" }} className={styles.container}>
      <div className={styles.headerContainer}>
        <h5 className={styles.header}>{category?.name || "Category Name"}</h5>
        {!noData && (
          <CustomButton text="Add Session" onClick={handleAddSession} />
        )}
      </div>
      <hr className="m-0" />
      <div
        style={{
          justifyContent: noData ? "center" : "flex-start",
        }}
        className={styles.sessionsContainer}
      >
        {!noData ? (
          <div className="mt-3">
            <CustomTable
              rows={data.rows}
              headers={data.headers}
              onRowClick={() => {}}
              searchConfig={SEARCH_CONFIG}
              pagination={data.pagination}
              onPageChange={onPageChange}
              onVisibilityFilter={onVisibilityFilter}
              onSearchChange={onSearchChange}
              searchValue={searchValue}
              onDateFilterChange={onDateFilterChange}
            />
          </div>
        ) : (
          <>
            <img width="35%" src={noDataImg} alt="no data" />
            <h3 className={styles.noDataHeader}>No sessions found</h3>
            <p className={styles.noDataText}>
              There are no sessions in this category yet. Add your first
              AI-trained session to get started.
            </p>
            <CustomButton text="Add Session" onClick={handleAddSession} />
          </>
        )}
      </div>
    </div>
  );
}

export default Sessions;
